/*
  Default loader.

  The standard fullscreen skeleton overlay was removed application-wide, so
  every legacy `<Loader show={x} />` now renders nothing — no default
  placeholder flashes during quick loads. Page-specific skeletons remain.
*/

interface PropData {
    show: boolean;
}

const Loader = ({ show }: PropData) => {
    void show;
    return null;
};

export default Loader;
